































































































































































































































































































































































import { Component, Vue, Prop, Emit, Watch } from "vue-property-decorator";
import Campaign, { LineItem } from "@/models/campaign";
import { LayoutModule } from "@/store/layout";
import Company from "@/models/company";
import CompanyAPI from "@/services/companies";
import ContactAPI from "@/services/contacts";
import Contact from "@/models/contact";
import LineItemForm from "./LineItemForm.vue";
import LineItemTable from "./LineItemTable.vue";
import { cloneDeep } from "lodash";
import CAMPAIGN_STATUS_LIST from "@/constants/campaign";
import { UserModule } from "@/store/user";
import { LineItemModule } from "@/store/lineItem";
import BannerForm from "./BannerForm.vue";
import { Dialog, QueryParams } from "@/models/general";
import CampaignsAPI from "@/services/campaigns";
import AdUnitsAPI from "@/services/adUnits";
import AdUnit from "@/models/adUnit";
import UsersAPI from "@/services/users";
import User from "@/models/user";
import DefinitionsAPI from "@/services/definitions";
import { DefinitionList } from "@/models/definition";
import SitesAPI from "@/services/sites";
import Site from "@/models/site";
import moment from "moment";
import GenerateReport from "./GenerateReport.vue";
import ClientCampaignsPerformance from "@/views/Reports/ClientCampaignsPerformance/ClientCampaignsPerformance.vue";
import CampaignChangeLog from "./CampaignChangeLog.vue";

@Component({
  components: {
    LineItemTable,
    GenerateReport,
    CampaignChangeLog,
  },
})
export default class CampaignForm extends Vue {
  @Prop({ default: "campaigns.new_campaign" }) title!: string;
  @Prop({ default: undefined }) initialData!: Campaign;
  @Prop({ default: true }) edit!: boolean;
  @Prop({ default: true }) saveButton!: boolean;

  campaign: Campaign = new Campaign();
  companies: Company[] = [];
  adUnits: AdUnit[] = [];
  definitions: DefinitionList[] = [];
  sites: Site[] = [];
  users: User[] = [];
  contacts: Contact[] = [];
  statusList = CAMPAIGN_STATUS_LIST;
  selectedLineItems: LineItem[] = [];
  hightLightLineItem: string | (string | null)[] = "";
  generateReport = false;

  created(): void {
    LineItemModule.setLineItems([]);
    if (this.initialData) {
      this.campaign = cloneDeep(this.initialData);

      LineItemModule.setLineItems(this.campaign.lineItems);
    }
    this.getCompanies();
    this.getAdUnits();
    this.getUsers();
    this.getDefinitions();
    this.getSites();

    this.hightLightLineItem = this.$route.query.highlight_lineitem;
  }

  lineItems(): LineItem[] {
    return LineItemModule.lineItems;
  }

  get canChangeStatus(): boolean {
    return UserModule.isAdmin && this.initialData !== undefined;
  }

  get loaderIsVisible(): boolean {
    return LayoutModule.loaderIsVisible;
  }

  get price(): number {
    let price = 0;

    this.lineItems().forEach((lineItem: LineItem) => {
      const adUnit = this.adUnits.find((adUnit: AdUnit) => {
        return lineItem.adUnitId === adUnit.id;
      });
      if (adUnit) {
        // console.log(adUnit.name, adUnit.price);
      }

      price += adUnit ? adUnit.price : 0;
    });

    return price ? price : 0;
  }

  get isAdmin(): boolean {
    return UserModule.isAdmin;
  }

  get startDate(): string {
    let date: any;
    if (this.lineItems().length > 0) {
      date = moment(this.lineItems()[0].start);

      this.lineItems().forEach((lineItem) => {
        const d = moment(lineItem.start);
        if (d < date) {
          date = d;
        }
      });
    }
    return date ? date.format("DD/MM/YYYY") : "";
  }

  get endDate(): string {
    let date: any;
    if (this.lineItems().length > 0) {
      date = moment(this.lineItems()[0].end);

      this.lineItems().forEach((lineItem) => {
        const d = moment(lineItem.end);
        if (d > date) {
          date = d;
        }
      });
    }
    return date ? date.format("DD/MM/YYYY") : "";
  }

  async getCompanies(): Promise<void> {
    try {
      const params: QueryParams = {
        page: {
          size: -1,
        },
      };
      const r = await CompanyAPI.getCompanies(params);
      this.companies = r.data;
    } catch (e) {
      console.log(e);
    }
  }

  async getAdUnits(): Promise<void> {
    try {
      const params: QueryParams = {
        page: {
          size: -1,
        },
        fields: { ad_unit: ["id", "ref", "name", "price"].join(",") },
      };
      const r = await AdUnitsAPI.list(params);
      this.adUnits = r.data;
    } catch (e) {
      console.log(e);
    }
  }

  async getDefinitions(): Promise<void> {
    try {
      const r = await DefinitionsAPI.list(1, 1000);
      this.definitions = r.data;
    } catch (e) {
      console.log(e);
    }
  }

  async getSites(): Promise<void> {
    try {
      const params: QueryParams = {
        page: {
          size: -1,
        },
      };
      const r = await SitesAPI.getSites(params);
      this.sites = r.data;
    } catch (e) {
      console.log(e);
    }
  }

  async getUsers(): Promise<void> {
    if (this.isAdmin) {
      try {
        const params: QueryParams = {
          page: {
            size: -1,
          },
        };

        const r = await UsersAPI.getUsers(params);
        console.log(r);

        this.users = r.data;
      } catch (e) {
        console.log(e);
      }
    } else {
      if (
        this.campaign.id &&
        UserModule.getCurrentUser.id !== this.campaign.userId
      ) {
        const r = await UsersAPI.getUser(this.campaign.userId);
        this.users.push(r);
      } else {
        this.users.push(UserModule.getCurrentUser);
      }
    }
  }

  async fetchlineItems(): Promise<void> {
    if (this.campaign.id) {
      // console.log(this.campaign.id);
      const r = await CampaignsAPI.get(this.campaign.id);
      this.campaign.lineItems = r.lineItems;
      LineItemModule.setLineItems(r.lineItems);
    }
  }

  @Watch("campaign.companyId", { deep: true })
  async getContacst(): Promise<void> {
    try {
      const params: QueryParams = {
        page: {
          number: -1,
        },
      };
      const r = await ContactAPI.getContacts(params, this.campaign.companyId);
      this.contacts = r.data;
    } catch (e) {
      console.log(e);
    }
  }

  validate(): void {
    const validForm = (this.$refs.form as Vue & {
      validate: () => boolean;
    }).validate();
    validForm ? this.save() : null;
  }

  showRightDrawer(multiple?: boolean): void {
    // TODO: Reset component on drawer close

    const props = {
      multiple: multiple ? true : false,
      edit: false,
    };

    LayoutModule.setRightDrawerComponent(LineItemForm);
    LayoutModule.setRightDrawerComponentProps(props);
    LayoutModule.showRightDrawer();
  }

  batchBannerAssign(): void {
    const props = {
      batch: true,
      lineItems: this.selectedLineItems,
    };

    // LineItemModule.setSelectedLineItems(this.selectedLineItems);

    LayoutModule.setRightDrawerComponent(BannerForm);
    LayoutModule.setRightDrawerComponentProps(props);
    LayoutModule.showRightDrawer();
  }

  async updateLineItem(e: LineItem): Promise<void> {
    const lineItems: LineItem[] = this.campaign.lineItems;
    lineItems.forEach((item: LineItem, idx: number) => {
      if (item.id === e.id && this.campaign) {
        // ObjectsHelper.updateProperties(this.campaign.lineItems[idx], e);
      }
    });
  }

  onSelectLineItems(lineItems: LineItem[]): void {
    this.selectedLineItems = lineItems;
  }

  onDeleteLineItem(lineItem: LineItem): void {
    LayoutModule.setDialogTitle("campaigns.line_items.delete_line_item");
    LayoutModule.setDialogType("error");
    LayoutModule.setDialogCallback(
      async (): Promise<null> => {
        LayoutModule.showLoader();

        if (lineItem.id) {
          await CampaignsAPI.lineItems.delete(lineItem.id, this.campaign.id);
          this.fetchlineItems();
        } else {
          const lineItems = [...LineItemModule.lineItems];
          const idx = lineItems.map((e) => e.localId).indexOf(lineItem.localId);
          lineItems.splice(idx, 1);
          LineItemModule.setLineItems(lineItems);
        }

        LayoutModule.hideLoader();
        LayoutModule.hideDialog();
        return null;
      }
    );
    LayoutModule.showDialog();
  }

  batchDeleteLineItems(): void {
    LayoutModule.setDialogTitle(
      this.$t("campaigns.line_items.delete_line_items_confirm").toString()
    );
    LayoutModule.setDialogText(
      this.$t("campaigns.line_items.delete_line_items_confirm_text").toString()
    );
    LayoutModule.setDialogType("error");
    LayoutModule.setDialogCallback(
      async (): Promise<null> => {
        try {
          const lineItems = [...LineItemModule.lineItems];
          LayoutModule.showLoader();
          if (this.campaign.id) {
            await CampaignsAPI.lineItems.batch.delete(
              this.selectedLineItems,
              this.campaign.id as string
            );

            this.selectedLineItems.forEach((i) => {
              const idx = lineItems.map((e) => e.id).indexOf(i.id);
              lineItems.splice(idx, 1);
            });
          } else {
            this.selectedLineItems.forEach((i) => {
              const idx = lineItems.map((e) => e.localId).indexOf(i.localId);
              lineItems.splice(idx, 1);
            });
          }
          LineItemModule.setLineItems(lineItems);

          LayoutModule.setAlerts({
            text: this.$t(
              "campaigns.responses.success_line_item_delete"
            ).toString(),
            type: "success",
          });
        } catch (e) {
          LayoutModule.setAlerts({
            text: this.$t("responses.error_line_item_delete").toString(),
            type: "error",
          });
          console.log(e);
        } finally {
          LayoutModule.hideLoader();
          LayoutModule.hideDialog();
        }

        //
        return null;
      }
    );
    LayoutModule.showDialog();
  }

  batchEditLineItems(): void {
    LineItemModule.setSelectedLineItems(this.selectedLineItems);

    LayoutModule.setRightDrawerComponent(LineItemForm);
    LayoutModule.setRightDrawerComponentProps({
      initialLineItems: this.selectedLineItems,
      multiple: true,
      edit: true,
    });
    LayoutModule.showRightDrawer();
  }

  async duplicateCampaign(): Promise<void> {
    const dialog: Dialog = {
      show: false,
      title: this.$t("campaign.duplicate.title").toString(),
      text: this.$t("campaign.duplicate.text").toString(),
      cancelButton: "cancel",
      successButton: {
        text: this.$t("general.duplicate").toString(),
        type: "primary",
        callback: async () => {
          LayoutModule.showLoader();
          try {
            const r = await CampaignsAPI.duplicate(this.campaign.id as string);

            LayoutModule.setAlerts({
              text: this.$t("campaign.duplicate.success").toString(),
              meta: [
                {
                  campaignId: r.id,
                  lineItemId: "-",
                },
              ],
              type: "success",
            });
          } catch (e) {
            LayoutModule.setAlerts({
              text: this.$t("campaign.duplicate.error").toString(),
              type: "error",
            });
            console.log(e);
          } finally {
            LayoutModule.hideLoader();
          }

          return null;
        },
      },
    };
    LayoutModule.setDialog(dialog);
    LayoutModule.showDialog();
  }

  @Emit()
  save(): Campaign {
    return this.campaign;
  }

  @Emit()
  cancel(): null {
    return null;
  }

  validateConflicts(): null {
    return null;
  }

  goToReport(): void {
    let routeData = this.$router.resolve({
      name: "campaign-report",
    });

    window.open(routeData.href, "_blank");
  }

  goToAvailability(): void {
    let routeData = this.$router.resolve({
      name: "availability",
    });
    window.open(routeData.href, "_blank");
  }

  canSave(): boolean {
    let r = true;
    if (this.campaign.id) {
      this.campaign.userId != UserModule.currentUser.id ? (r = false) : null;
    }

    if (UserModule.isAdmin) r = true;

    return r;
  }

  historicPerformance(): void {
    const dialog = new Dialog();
    dialog.showCancelButton = true;
    dialog.successButton.text = "";
    dialog.width = 1280;
    dialog.title = this.$t(
      "reports.client_campaign_performance.title"
    ) as string;
    dialog.component = ClientCampaignsPerformance;
    dialog.componentProps = {
      // inputCompany: get(this.campaign.companyId, "campaign.company"),
      inputCompany: this.campaign.company,
    };

    LayoutModule.setDialogType("info");
    LayoutModule.setDialog(dialog);

    LayoutModule.setDialogCallback(
      async (): Promise<null> => {
        return null;
      }
    );

    LayoutModule.showDialog();
  }

  showChangeLog(): void {
    const dialog = new Dialog();
    dialog.showCancelButton = true;
    dialog.width = 600;
    dialog.title = "Changelog";
    dialog.component = CampaignChangeLog;
    dialog.componentProps = {
      campaign: this.campaign,
      sites: this.sites,
      definitions: this.definitions,
      adUnits: this.adUnits,
    };

    LayoutModule.setDialogType("info");
    LayoutModule.setDialog(dialog);

    this.campaign.id ? LayoutModule.showDialog() : null;
  }
}
